<template>
  <main role="main" class="py-4">
    <b-container fluid="xl" class="mb-3">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("customerUserAccountList") }}</h4>
        <div>
          <!-- <b-button variant="outline-secondary" class="mr-4" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button> -->

          <b-button class="mr-4" variant="outline-success" @click="debouncedOnClickDownload()">
            <b-icon icon="download" class="mr-2"></b-icon> {{ $t("export") }}
          </b-button>
          <b-button class="mr-4" variant="outline-secondary" v-b-modal:new-import-excel>
            <b-icon icon="upload" class="mr-2"></b-icon> {{ $t("importFromFile") }}
          </b-button>
          <b-button class="mr-4" variant="outline-primary" v-b-modal:new-customer-user-modal>
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button>
          <b-button variant="outline-danger" @click="onclickDeleteAllViewer">
            <b-icon icon="trash" class="mr-2"></b-icon> {{ $t("deleteAllViewer") }}
          </b-button>

        </div>
      </div>

      <div class="d-flex flex-row align-items-center justify-content-between mb-3">
        <div>
          <b-form class="d-inline-block" inline @submit.prevent="debounceonClickSearch">
            <b-form-input class="mr-2" type="search" minlength="2" maxlength="200" v-model="searchText"
              placeholder="Tìm theo tên, SĐT, email" style="min-width: 300px;" @keyup.enter="debounceonClickSearch" />
            <b-button type="submit" variant="primary">{{ $t("search") }}</b-button>
          </b-form>
        </div>
        <!-- <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}</div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div> -->
      </div>

      <b-table ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields" show-empty
        :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(name)="data">
          {{ data.item.name }}
        </template>
        <template v-slot:cell(actions)="data">
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none p-0" no-caret right
            menu-class="shadow">
            <template v-slot:button-content>
              <b-icon icon="three-dots" />
            </template>
            <b-dropdown-item-button @click="onClickEditCustomerUser(data.item)">{{ $t("updateInfo")
            }}</b-dropdown-item-button>
            <b-dropdown-item-button @click="onClickResetPassword(data.item)">{{ $t("resetPassword")
            }}</b-dropdown-item-button>
            <b-dropdown-item-button v-if="data.item.id !== userId" @click="onClickDeleteUser(data.item)">{{
              $t("actionDelete")
            }}</b-dropdown-item-button>
          </b-dropdown>
        </template>
      </b-table>

      <div class="d-flex flex-row align-items-center justify-content-between">
        <div></div>
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}
          </div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems"
            :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>
    </b-container>

    <b-modal id="new-customer-user-modal" :title="$t('createCustomerUserAccount')" dialog-class="min-width-700"
      hide-footer no-close-on-backdrop>
      <new-customer-user-modal @submitted="refreshData" />
    </b-modal>

    <b-modal id="edit-customer-user-modal" :title="$t('updateAccountInfo')" hide-footer no-close-on-backdrop>
      <edit-customer-user-modal :editing-user="userToEdit" @submitted="refreshData" />
    </b-modal>

    <b-modal id="reset-password-modal" :title="$t('resetPassword')" hide-footer no-close-on-backdrop>
      <reset-password-modal :target-user="userToEdit" @submitted="refreshData" />
    </b-modal>

    <b-modal id="import-users-from-excel-file-modal" :title="$t('importUserFromFile')" hide-footer no-close-on-backdrop>
      <ImportUsersFromExcelFileModal modal-id="import-users-from-excel-file-modal" @submitted="refreshData" />
    </b-modal>

    <!--Modal Import dữ liệu  @submitted="refreshData" -->
    <b-modal id="new-import-excel" :title="$t('importParticipants')" hide-footer no-close-on-backdrop size="md">
      <ImportExcelModal modal-id="new-import-excel" :activeFID="false" :typeModal="'user'"
        @imported="handleImportFileUsers"></ImportExcelModal>
    </b-modal>

    <!--Preview Modal-->
    <b-modal id="preview-import-modal" :title="$t('previewData')" hide-footer no-close-on-backdrop size="xl">
      <PreviewFileExcel modal-id="preview-import-modal" :activeFID="false" :initial-data="importData"
        :type-modal="'user'" @imported="handleFinalSave" />
    </b-modal>

  </main>
</template>

<style lang="scss" scoped></style>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import { BvTableFieldArray } from "bootstrap-vue";

import * as util from "@/service/util";
import * as userService from "@/service/userService";
import * as exportService from "@/service/exportService";
import ResetPasswordModal from "@/components/account/ResetPasswordModal.vue";
import EditCustomerUserModal from "@/components/customer/user-accounts/EditCustomerUserModal.vue";
import NewCustomerUserModal from "@/components/customer/user-accounts/NewCustomerUserModal.vue";
import ImportUsersFromExcelFileModal from '@/components/customer/user-accounts/ImportUsersFromExcelFileModal.vue';
import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";
import * as customerService from "@/service/customerService";
import { BounceTimes } from '../enums/TimesNumbers';
import ImportExcelModal from '@/components/modals/ImportExcelModal.vue';
import PreviewFileExcel from '@/components/modals/PreviewFileExcel.vue';
import { jsonToExcelFile } from '@/service/util';


@Component({
  components: { ImportUsersFromExcelFileModal, NewCustomerUserModal, EditCustomerUserModal, ResetPasswordModal, ImportExcelModal, PreviewFileExcel }
})
export default class CustomerUserAccounts extends BaseComponent {

  searchText = "";

  // Biến để xử lý data từ modal
  importData: any[] = [];

  @Ref("table") table: BTable;
  tableFields: BvTableFieldArray = [
    {
      key: "id",
      label: "#",
      thClass: "text-nowrap",
    },
    {
      key: "name",
      label: this.$t("fullName").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "username",
      label: "Tên đăng nhập",
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "phone",
      label: this.$t("phoneNumber").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "email",
      label: "Email",
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "role",
      label: this.$t("role").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
      formatter: value => ({
        Customer: this.$t("roleAdmin"),
        User: this.$t("user"),
        View: this.$t("viewOnly"),
      }[value])
    },
    {
      key: "createdAt",
      label: this.$t("createdDate").toString(),
      thClass: "text-nowrap",
      /*formatter: value => moment(value).format("DD/MM/YYYY")*/
    },
    {
      key: "actions",
      label: "",
      thClass: "text-nowrap",
      tdClass: "text-nowrap"
    }
  ];

  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];
  itemsPerPage = 20;
  currentPage = 1;
  totalItems = 0;

  userToEdit = null;

  mounted() {

  }

  onClickReloadBtn() {
    this.searchText = "";
    this.currentPage = 1;
    this.table.refresh();
  }

  //
  debouncedOnClickDownload = _.debounce(() => {
    this.onClickDownload();
  }, BounceTimes.BOUNCETIMES);
  async onClickDownload() {
    try {
      let customers = [];
      customers = await userService.getAllUserForExport();
      await exportService.exportUserList(customers);
    } catch (e) {
      console.error(e);
      this.toastError(e);
    }
  }

  async onclickDeleteAllViewer() {
    const modalMessage = this.$t("deleteAllViewerConfirmation").toString();
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });
    if (confirmDelete) {
      try {
        await userService.deleteAllViewer();
        this.toastSuccessDelay(this.$t("deleteAllViewerSuccess").toString());

        this.table.refresh();
      } catch (e) {
        console.error(e);
        this.toastError(e);
      }
    }
  }

  //
  debounceonClickSearch = _.debounce(() => {
    this.onClickSearch();
  }, BounceTimes.BOUNCETIMES);

  onClickSearch() {
    this.table.refresh();
  }

  refreshData() {
    this.table.refresh();
  }


  onClickEditCustomerUser(user) {
    this.userToEdit = user;
    this.$bvModal.show("edit-customer-user-modal");

  }

  onClickResetPassword(user) {
    this.userToEdit = user;
    this.$bvModal.show("reset-password-modal");
  }


  async onClickDeleteUser(user) {
    const modalMessage = this.$t("deleteAccountConfirmation", { account: user.name }).toString() + `(ID: ${user.id})?`;
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmDelete) {
      try {
        await userService.deleteUser(user.id);
        this.refreshData();
        this.toastSuccessDelay(this.$t("deleteAccountSuccess").toString());

      } catch (e) {
        this.toastError(e);
      }
    }
  }


  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    try {
      const res = await userService.getCustomerUsers({
        page: ctx.currentPage,
        pageSize: this.itemsPerPage,
        q: this.searchText?.trim(),
      });

      this.totalItems = res.total;
      return res.data;

    } catch (e) {
      this.toastError(e);
      return [];
    }
  }

  // ==============================
  // Các hàm xử lý import từ file Excel
  // + Preview modal
  // + Lưu dữ liệu cuối cùng
  // ==============================

  /**
   * Tạo key duy nhất cho 1 participant
   * Dùng để so sánh trùng dữ liệu khi import
   * Key = name | email | phone (đã normalize)
   */
  private buildParticipantKey(p: any): string {
    const name = (p.name || "").trim().toLowerCase();   // Chuẩn hóa tên
    const email = (p.email || "").trim().toLowerCase(); // Chuẩn hóa email
    const phone = (p.phone || "").toString().trim();    // Chuẩn hóa phone

    return `${name}|${email}|${phone}`;
  }

  /**
   * Nhận dữ liệu sau khi import file Excel
   * - Lưu data
   * - Đóng modal import
   * - Mở modal preview nếu có dữ liệu
   */
  handleImportFileUsers(data: any[]) {

    // Lưu dữ liệu import
    this.importData = data;

    // Đóng modal chọn file
    this.$bvModal.hide('new-import-excel');

    // Delay nhỏ để modal đóng hoàn toàn
    setTimeout(() => {
      if (this.importData && this.importData.length > 0) {
        // Có dữ liệu → mở modal preview
        this.$bvModal.show('preview-import-modal');
      } else {
        // File rỗng hoặc lỗi parse
        console.error("Lỗi file rỗng hoặc lỗi file. Xem lại file");
      }
    }, 300);
  }

  /**
      * Lưu dữ liệu sau khi user confirm ở modal preview
      * - Bỏ qua dữ liệu trùng
      * - Kiểm tra giới hạn số lượng
      * - Insert vào danh sách participants
      */
  // Hàm xử lý khi bấm nút xác nhận modal preview
  async handleFinalSave(finalData: any[]) {
    if (!finalData || !finalData.length) return;

    try {
      const file = jsonToExcelFile(finalData, "contacts-import.xlsx");

      await userService.uploadUsersExcelFile(file);

      this.$bvModal.hide("preview-import-modal");
      this.importData = [];
      this.refreshData();

      this.toastSuccessDelay(
        this.$t("importContactsFromFileSuccessful").toString()
      );
    } catch (err: any) {



      console.log(err);
      this.toastError(err);
      return;
      // ✅ dùng message backend
      this.toastError(
        err?.message
      );

      // debug khi cần
      console.error("Import error:", err?.code, err);
    }
  }



}
</script>
